import React from 'react';
import Marquee from "react-fast-marquee";

const Slider = () => {
  return (
    <div className='text-white overflow-x-hidden font-inria'>
      <div>
      <Marquee direction='right' className='overflow-x-hidden' style={{zIndex:0}}>
        <div className='flex space-x-10 md:space-x-20'>
        <div className='pl-4'>
            <h1 className='border-2 border-gray-500 rounded-3xl px-6 py-1 md:px-8 md:py-2 md:text-2xl text-lg'>Front-End</h1>
        </div>
        <div className='pl-4'>
            <h1 className='border-2 border-gray-500 rounded-3xl px-6 py-1 md:px-8 md:py-2 md:text-2xl text-lg'>Back-End</h1>
        </div>
        <div className='pl-4'>
            <h1 className='border-2 border-gray-500 rounded-3xl px-6 py-1 md:px-8 md:py-2 md:text-2xl text-lg'>DataBase</h1>
        </div>
        <div className=''>
            <h1 className='border-2 border-gray-500 rounded-3xl px-6 py-1 md:px-8 md:py-2 md:text-2xl text-lg'>API Integration</h1>
        </div>
        <div className=''>
            <h1 className='border-2 border-gray-500 rounded-3xl px-6 py-1 md:px-8 md:py-2 md:text-2xl text-lg'>Project Managment</h1>
        </div>
        <div className=''>
            <h1 className='border-2 border-gray-500 rounded-3xl px-6 py-1 md:px-8 md:py-2 md:text-2xl text-lg'>Responsive Design</h1>
        </div>
        <div className='pr-4'>
            <h1 className='border-2 border-gray-500 rounded-3xl px-6 py-1 md:px-8 md:py-2 md:text-2xl text-lg'>Deployment</h1>
        </div>
        </div>
      </Marquee>
      </div>
    </div>
  )
}

export default Slider
